module.exports = __webpack_public_path__ + "img/gaikuang.1abd591b.svg";